import { request } from "../lib/requestHelper";
 
export const getGlobalSearchSuggestions = async (query) => {
  if (!query || query.trim().length === 0) {
    return [];
  }

  try {
    const data = await request(`api/global-search?query=${encodeURIComponent(query)}`, { method: "GET" });
    return data.result || [];
  } catch (error) {
    console.error('Search failed:', error);
    return [];
  }
};
